import request from '../utils/request.js'
import { getToken } from '../utils/dataStorage.js'
import { buildVerifySignatureParams } from '../utils/clientInfo.js'


export function ChartsYybApi(params) {
    return request({
        url: '/admin/charts/reg/yyb?' + params,
        method: 'get',
        closeLoading: true //closeInterceptors:true  (请求没有Loading，请求没有拦截)
    })
}


// ============ 限时邀请活动 ============
// 绑定邀请码（被邀请人绑定邀请人）
export function ActivityBindingApi(params) {
    return request({
        url: '/v2/activity_binding',
        method: 'post',
        data: params,
        headers: { Token: getToken() }
    })
}

// 查询当前用户已绑定的邀请码及邀请人详情（closeInterceptors 保留 data:null 区分未绑定）
export function InviteBindingApi(params) {
    return request({
        url: '/v2/invite_binding',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 邀请绑定预览（绑定前查询邀请人信息与前置校验，closeInterceptors 保留 can_bind/reason）
export function InviteBindingPreviewApi(params) {
    return request({
        url: '/v2/invite_binding_preview',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 被邀请人提现记录（closeInterceptors 保留 count 字段）
export function InviteeWithdrawRecordsApi(params) {
    return request({
        url: '/v2/invitee_withdraw_records',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 被邀请人名单（closeInterceptors 保留 count 字段）
export function InviteeListApi(params) {
    return request({
        url: '/v2/invitee_list',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// ============ 问题反馈有奖活动 ============
// 提交问题反馈
export function FeedbackSubmitApi(params) {
    return request({
        url: '/v2/feedback_submit',
        method: 'post',
        data: params,
        headers: { Token: getToken() }
    })
}

// 我的反馈/中奖记录（closeInterceptors 保留 count 字段）
// URL 同步表名变更：feedback_record -> activity_feedback_record
export function FeedbackRecordsApi(params) {
    return request({
        url: '/v2/activity_feedback_records',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 全部反馈记录（脱敏展示，仅审核中/已奖励）
// URL 同步表名变更：feedback_record -> activity_feedback_record
export function FeedbackAllRecordsApi(params) {
    return request({
        url: '/v2/activity_feedback_all_records',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 上传反馈问题图片
export function FeedbackUploadImageApi(formData) {
    return request({
        url: '/v2/feedback_upload_image',
        method: 'post',
        data: formData,
        headers: { Token: getToken(), 'Content-Type': 'multipart/form-data' },
        timeout: 30000
    })
}

// ============ 提现奖励活动（限定活动·热力开启） ============
// 我的返现进度（累计提现/门槛/比例/新人标识）
export function CashbackStatusApi(params) {
    return request({
        url: '/v2/cashback_status',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 我的返现进度（限定活动·热力开启2，5%-10% 阶梯）
export function CashbackStatus2Api(params) {
    return request({
        url: '/v2/cashback_status2',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 返现发放记录
export function CashbackRecordsApi(params) {
    return request({
        url: '/v2/cashback_records',
        method: 'get',
        params: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// ============ 签名验证 ============
// 验证当前 URL 签名参数是否有效（轻量级身份校验接口）
// 自动注入前端采集的 page_url（当前页面地址）与 client_info（设备/环境信息），
// 用于后端 activity_access_log 审计；采集逻辑在 clientInfo.js 中实现，
// 调用方无需显式传参，保持各活动页 mounted 调用方式不变。
export function VerifySignatureApi(params) {
    const extra = buildVerifySignatureParams();
    const merged = Object.assign({}, extra, params || {});
    return request({
        url: '/v2/verify_signature',
        method: 'get',
        params: merged,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 邀请活动返现奖励批量提现（closeInterceptors 保留 record_count/amount 字段）
export function RewardWithdrawApi() {
    return request({
        url: '/v2/reward_withdraw',
        method: 'post',
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// ============ 邀请好友活动 ============
// 邀请好友-手机号预填充（closeInterceptors 保留 code/msg/data 完整结构）
export function InviteFriendPrefillApi(params) {
    return request({
        url: '/v2/invite_friend_prefill',
        method: 'post',
        data: params,
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}

// 邀请好友-自动绑定（closeInterceptors 保留绑定结果数据）
export function InviteFriendAutoBindApi() {
    return request({
        url: '/v2/invite_friend_auto_bind',
        method: 'post',
        headers: { Token: getToken() },
        closeLoading: true,
        closeInterceptors: true
    })
}




